var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.item > 0)?_c('div',[_c('span',{staticClass:"link-like",on:{"click":_vm.openActiveContactsList}},[_vm._v(_vm._s(_vm.item))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }